module.exports = __webpack_public_path__ + "static/img/game2.910b7a7c.png";